import { render, staticRenderFns } from "./CrystalBallIcon.vue?vue&type=template&id=0c98151e&"
import script from "./CrystalBallIcon.vue?vue&type=script&lang=js&"
export * from "./CrystalBallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports